/* unplugin-vue-components disabled */import { render } from "./c-columns.vue?vue&type=template&id=4004e100&scoped=true"
import script from "./c-columns.vue?vue&type=script&lang=js"
export * from "./c-columns.vue?vue&type=script&lang=js"

import "./c-columns.vue?vue&type=style&index=0&id=4004e100&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4004e100"]])

export default __exports__